(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("iPXNi", function(module, exports) {

var $kD3cm = parcelRequire("kD3cm");
$parcel$exportWildcard(module.exports, $kD3cm);

});
parcelRegister("kD3cm", function(module, exports) {

$parcel$export(module.exports, "settings", function () { return $f049ee4efddae9c4$export$a5a6e0b888b2c992; });
$parcel$export(module.exports, "getAnalytics", function () { return $f049ee4efddae9c4$export$b0297573c90085aa; });
$parcel$export(module.exports, "initializeAnalytics", function () { return $f049ee4efddae9c4$export$e1ffb6ba450b0317; });
$parcel$export(module.exports, "isSupported", function () { return $f049ee4efddae9c4$export$48c17662a6902497; });
$parcel$export(module.exports, "setCurrentScreen", function () { return $f049ee4efddae9c4$export$a364c5ef84862575; });
$parcel$export(module.exports, "setUserId", function () { return $f049ee4efddae9c4$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "setUserProperties", function () { return $f049ee4efddae9c4$export$d0e176862bf869b8; });
$parcel$export(module.exports, "setAnalyticsCollectionEnabled", function () { return $f049ee4efddae9c4$export$7d544a250c4ed423; });
$parcel$export(module.exports, "logEvent", function () { return $f049ee4efddae9c4$export$5e9eec8001665ac5; });

var $5YOUh = parcelRequire("5YOUh");

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $fKBt2 = parcelRequire("fKBt2");

var $kekIc = parcelRequire("kekIc");

var $j4B9x = parcelRequire("j4B9x");

var $gsN9U = parcelRequire("gsN9U");

var $jhFYS = parcelRequire("jhFYS");

var $dqzVW = parcelRequire("dqzVW");

var $8WxDc = parcelRequire("8WxDc");
parcelRequire("eY6nt");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ var $f049ee4efddae9c4$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
var $f049ee4efddae9c4$var$GA_FID_KEY = "firebase_id";
var $f049ee4efddae9c4$var$ORIGIN_KEY = "origin";
var $f049ee4efddae9c4$var$FETCH_TIMEOUT_MILLIS = 60000;
var $f049ee4efddae9c4$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
var $f049ee4efddae9c4$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f049ee4efddae9c4$var$logger = new (0, $jhFYS.Logger)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $f049ee4efddae9c4$var$promiseAllSettled(promises) {
    return Promise.all(promises.map(function(promise) {
        return promise.catch(function(e) {
            return e;
        });
    }));
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $f049ee4efddae9c4$var$insertScriptTag(dataLayerName, measurementId) {
    var script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    script.src = "".concat($f049ee4efddae9c4$var$GTAG_URL, "?l=").concat(dataLayerName, "&id=").concat(measurementId);
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $f049ee4efddae9c4$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
function $f049ee4efddae9c4$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    return $f049ee4efddae9c4$var$_gtagOnConfig.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_gtagOnConfig() {
    $f049ee4efddae9c4$var$_gtagOnConfig = /**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ (0, $5YOUh._)(function(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
        var correspondingAppId, dynamicConfigResults, foundConfig, e;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If config is already fetched, we know the appId and can use it to look up what FID promise we
                    /// are waiting for, and wait only on that one.
                    correspondingAppId = measurementIdToAppId[measurementId];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!correspondingAppId) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        initializationPromisesMap[correspondingAppId]
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    return [
                        4,
                        $f049ee4efddae9c4$var$promiseAllSettled(dynamicConfigPromisesList)
                    ];
                case 4:
                    dynamicConfigResults = _state.sent();
                    foundConfig = dynamicConfigResults.find(function(config) {
                        return config.measurementId === measurementId;
                    });
                    if (!foundConfig) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        initializationPromisesMap[foundConfig.appId]
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    e = _state.sent();
                    $f049ee4efddae9c4$var$logger.error(e);
                    return [
                        3,
                        8
                    ];
                case 8:
                    gtagCore("config" /* CONFIG */ , measurementId, gtagParams);
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_gtagOnConfig.apply(this, arguments);
}
function $f049ee4efddae9c4$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    return $f049ee4efddae9c4$var$_gtagOnEvent.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_gtagOnEvent() {
    $f049ee4efddae9c4$var$_gtagOnEvent = /**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ (0, $5YOUh._)(function(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
        var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, e;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    initializationPromisesToWaitFor = [];
                    if (!(gtagParams && gtagParams["send_to"])) return [
                        3,
                        2
                    ];
                    gaSendToList = gtagParams["send_to"];
                    // Make it an array if is isn't, so it can be dealt with the same way.
                    if (!Array.isArray(gaSendToList)) gaSendToList = [
                        gaSendToList
                    ];
                    return [
                        4,
                        $f049ee4efddae9c4$var$promiseAllSettled(dynamicConfigPromisesList)
                    ];
                case 1:
                    dynamicConfigResults = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var sendToId = _step.value;
                            // Any fetched dynamic measurement ID that matches this 'send_to' ID
                            var foundConfig = dynamicConfigResults.find(function(config) {
                                return config.measurementId === sendToId;
                            });
                            var initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                            if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                            else {
                                // Found an item in 'send_to' that is not associated
                                // directly with an FID, possibly a group.  Empty this array,
                                // exit the loop early, and let it get populated below.
                                initializationPromisesToWaitFor = [];
                                return "break";
                            }
                        };
                        for(_iterator = gaSendToList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _ret = _loop();
                            if (_ret === "break") break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _state.label = 2;
                case 2:
                    // This will be unpopulated if there was no 'send_to' field , or
                    // if not all entries in the 'send_to' field could be mapped to
                    // a FID. In these cases, wait on all pending initialization promises.
                    if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    return [
                        4,
                        Promise.all(initializationPromisesToWaitFor)
                    ];
                case 3:
                    _state.sent();
                    // Workaround for http://b/141370449 - third argument cannot be undefined.
                    gtagCore("event" /* EVENT */ , measurementId, gtagParams || {});
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    $f049ee4efddae9c4$var$logger.error(e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_gtagOnEvent.apply(this, arguments);
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $f049ee4efddae9c4$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    function gtagWrapper(command, idOrNameOrParams, gtagParams) {
        return _gtagWrapper.apply(this, arguments);
    }
    function _gtagWrapper() {
        _gtagWrapper = /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ (0, $5YOUh._)(function(command, idOrNameOrParams, gtagParams) {
            var e;
            return (0, $j4B9x.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!(command === "event" /* EVENT */ )) return [
                            3,
                            2
                        ];
                        // If EVENT, second arg must be measurementId.
                        return [
                            4,
                            $f049ee4efddae9c4$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, idOrNameOrParams, gtagParams)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!(command === "config" /* CONFIG */ )) return [
                            3,
                            4
                        ];
                        // If CONFIG, second arg must be measurementId.
                        return [
                            4,
                            $f049ee4efddae9c4$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, idOrNameOrParams, gtagParams)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        // If SET, second arg must be params.
                        gtagCore("set" /* SET */ , idOrNameOrParams);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        $f049ee4efddae9c4$var$logger.error(e);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _gtagWrapper.apply(this, arguments);
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $f049ee4efddae9c4$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function gtagCore() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++){
            _args[_key] = arguments[_key];
        }
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $f049ee4efddae9c4$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns first script tag in DOM matching our gtag url pattern.
 */ function $f049ee4efddae9c4$var$findGtagScriptOnPage() {
    var scriptTags = window.document.getElementsByTagName("script");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(scriptTags)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tag = _step.value;
            if (tag.src && tag.src.includes($f049ee4efddae9c4$var$GTAG_URL)) return tag;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $f049ee4efddae9c4$var$_obj;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f049ee4efddae9c4$var$ERRORS = ($f049ee4efddae9c4$var$_obj = {}, (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "already-exists" /* ALREADY_EXISTS */ , "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId."), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "already-initialized" /* ALREADY_INITIALIZED */ , "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance."), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "already-initialized-settings" /* ALREADY_INITIALIZED_SETTINGS */ , "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect."), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ , "Firebase Analytics Interop Component failed to instantiate: {$reason}"), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ , "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}"), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}"), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "fetch-throttle" /* FETCH_THROTTLE */ , "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}."), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "config-fetch-failed" /* CONFIG_FETCH_FAILED */ , "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}"), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "no-api-key" /* NO_API_KEY */ , 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.'), (0, $fKBt2._)($f049ee4efddae9c4$var$_obj, "no-app-id" /* NO_APP_ID */ , 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.'), $f049ee4efddae9c4$var$_obj);
var $f049ee4efddae9c4$var$ERROR_FACTORY = new (0, $dqzVW.ErrorFactory)("analytics", "Analytics", $f049ee4efddae9c4$var$ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ var $f049ee4efddae9c4$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ var $f049ee4efddae9c4$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ var $f049ee4efddae9c4$var$RetryData = /*#__PURE__*/ function() {
    "use strict";
    function RetryData() {
        var throttleMetadata = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f049ee4efddae9c4$var$BASE_INTERVAL_MILLIS;
        (0, $6Tsgf._)(this, RetryData);
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    (0, $hmsbi._)(RetryData, [
        {
            key: "getThrottleMetadata",
            value: function getThrottleMetadata(appId) {
                return this.throttleMetadata[appId];
            }
        },
        {
            key: "setThrottleMetadata",
            value: function setThrottleMetadata(appId, metadata) {
                this.throttleMetadata[appId] = metadata;
            }
        },
        {
            key: "deleteThrottleMetadata",
            value: function deleteThrottleMetadata(appId) {
                delete this.throttleMetadata[appId];
            }
        }
    ]);
    return RetryData;
}();
var $f049ee4efddae9c4$var$defaultRetryData = new $f049ee4efddae9c4$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $f049ee4efddae9c4$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $f049ee4efddae9c4$var$fetchDynamicConfig(appFields) {
    return $f049ee4efddae9c4$var$_fetchDynamicConfig.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_fetchDynamicConfig() {
    $f049ee4efddae9c4$var$_fetchDynamicConfig = /**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ (0, $5YOUh._)(function(appFields) {
        var _a, appId, apiKey, request, appUrl, response, errorMessage, jsonResponse, _ignored;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appId = appFields.appId, apiKey = appFields.apiKey;
                    request = {
                        method: "GET",
                        headers: $f049ee4efddae9c4$var$getHeaders(apiKey)
                    };
                    appUrl = $f049ee4efddae9c4$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
                    return [
                        4,
                        fetch(appUrl, request)
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status !== 200 && response.status !== 304)) return [
                        3,
                        6
                    ];
                    errorMessage = "";
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    jsonResponse = _state.sent();
                    if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
                    return [
                        3,
                        5
                    ];
                case 4:
                    _ignored = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("config-fetch-failed" /* CONFIG_FETCH_FAILED */ , {
                        httpStatus: response.status,
                        responseMessage: errorMessage
                    });
                case 6:
                    return [
                        2,
                        response.json()
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_fetchDynamicConfig.apply(this, arguments);
}
function $f049ee4efddae9c4$var$fetchDynamicConfigWithRetry(app) {
    return $f049ee4efddae9c4$var$_fetchDynamicConfigWithRetry.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_fetchDynamicConfigWithRetry() {
    $f049ee4efddae9c4$var$_fetchDynamicConfigWithRetry = /**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ (0, $5YOUh._)(function(app) {
        var // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
        retryData, timeoutMillis, _app_options, appId, apiKey, measurementId, throttleMetadata, signal;
        var _arguments = arguments;
        return (0, $j4B9x.__generator)(this, function(_state) {
            retryData = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : $f049ee4efddae9c4$var$defaultRetryData, timeoutMillis = _arguments.length > 2 ? _arguments[2] : void 0;
            _app_options = app.options, appId = _app_options.appId, apiKey = _app_options.apiKey, measurementId = _app_options.measurementId;
            if (!appId) throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
            if (!apiKey) {
                if (measurementId) return [
                    2,
                    {
                        measurementId: measurementId,
                        appId: appId
                    }
                ];
                throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
            }
            throttleMetadata = retryData.getThrottleMetadata(appId) || {
                backoffCount: 0,
                throttleEndTimeMillis: Date.now()
            };
            signal = new $f049ee4efddae9c4$var$AnalyticsAbortSignal();
            setTimeout(/*#__PURE__*/ (0, $5YOUh._)(function() {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                    signal.abort();
                    return [
                        2
                    ];
                });
            }), timeoutMillis !== undefined ? timeoutMillis : $f049ee4efddae9c4$var$FETCH_TIMEOUT_MILLIS);
            return [
                2,
                $f049ee4efddae9c4$var$attemptFetchDynamicConfigWithRetry({
                    appId: appId,
                    apiKey: apiKey,
                    measurementId: measurementId
                }, throttleMetadata, signal, retryData)
            ];
        });
    });
    return $f049ee4efddae9c4$var$_fetchDynamicConfigWithRetry.apply(this, arguments);
}
function $f049ee4efddae9c4$var$attemptFetchDynamicConfigWithRetry(appFields, _, signal) {
    return $f049ee4efddae9c4$var$_attemptFetchDynamicConfigWithRetry.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_attemptFetchDynamicConfigWithRetry() {
    $f049ee4efddae9c4$var$_attemptFetchDynamicConfigWithRetry = /**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ (0, $5YOUh._)(function(appFields, param, signal) {
        var throttleEndTimeMillis, backoffCount, retryData, appId, measurementId, e, response, e1, backoffMillis, throttleMetadata;
        var _arguments = arguments;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    throttleEndTimeMillis = param.throttleEndTimeMillis, backoffCount = param.backoffCount, retryData = _arguments.length > 3 && _arguments[3] !== void 0 // for testing
                     ? _arguments[3] : $f049ee4efddae9c4$var$defaultRetryData;
                    appId = appFields.appId, measurementId = appFields.measurementId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $f049ee4efddae9c4$var$setAbortableTimeout(signal, throttleEndTimeMillis)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    if (measurementId) {
                        $f049ee4efddae9c4$var$logger.warn("Timed out fetching this Firebase app's measurement ID from the server." + " Falling back to the measurement ID ".concat(measurementId) + ' provided in the "measurementId" field in the local Firebase config. ['.concat(e.message, "]"));
                        return [
                            2,
                            {
                                appId: appId,
                                measurementId: measurementId
                            }
                        ];
                    }
                    throw e;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        $f049ee4efddae9c4$var$fetchDynamicConfig(appFields)
                    ];
                case 5:
                    response = _state.sent();
                    // Note the SDK only clears throttle state if response is success or non-retriable.
                    retryData.deleteThrottleMetadata(appId);
                    return [
                        2,
                        response
                    ];
                case 6:
                    e1 = _state.sent();
                    if (!$f049ee4efddae9c4$var$isRetriableError(e1)) {
                        retryData.deleteThrottleMetadata(appId);
                        if (measurementId) {
                            $f049ee4efddae9c4$var$logger.warn("Failed to fetch this Firebase app's measurement ID from the server." + " Falling back to the measurement ID ".concat(measurementId) + ' provided in the "measurementId" field in the local Firebase config. ['.concat(e1.message, "]"));
                            return [
                                2,
                                {
                                    appId: appId,
                                    measurementId: measurementId
                                }
                            ];
                        } else throw e1;
                    }
                    backoffMillis = Number(e1.customData.httpStatus) === 503 ? (0, $dqzVW.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $f049ee4efddae9c4$var$LONG_RETRY_FACTOR) : (0, $dqzVW.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
                    // Increments backoff state.
                    throttleMetadata = {
                        throttleEndTimeMillis: Date.now() + backoffMillis,
                        backoffCount: backoffCount + 1
                    };
                    // Persists state.
                    retryData.setThrottleMetadata(appId, throttleMetadata);
                    $f049ee4efddae9c4$var$logger.debug("Calling attemptFetch again in ".concat(backoffMillis, " millis"));
                    return [
                        2,
                        $f049ee4efddae9c4$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData)
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_attemptFetchDynamicConfigWithRetry.apply(this, arguments);
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $f049ee4efddae9c4$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function(resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function() {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($f049ee4efddae9c4$var$ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $f049ee4efddae9c4$var$isRetriableError(e) {
    if (!(e instanceof (0, $dqzVW.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ var $f049ee4efddae9c4$var$AnalyticsAbortSignal = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsAbortSignal() {
        (0, $6Tsgf._)(this, AnalyticsAbortSignal);
        this.listeners = [];
    }
    (0, $hmsbi._)(AnalyticsAbortSignal, [
        {
            key: "addEventListener",
            value: function addEventListener(listener) {
                this.listeners.push(listener);
            }
        },
        {
            key: "abort",
            value: function abort() {
                this.listeners.forEach(function(listener) {
                    return listener();
                });
            }
        }
    ]);
    return AnalyticsAbortSignal;
}();
function $f049ee4efddae9c4$var$validateIndexedDB() {
    return $f049ee4efddae9c4$var$_validateIndexedDB.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_validateIndexedDB() {
    $f049ee4efddae9c4$var$_validateIndexedDB = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5YOUh._)(function() {
        var e;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!(0, $dqzVW.isIndexedDBAvailable)()) return [
                        3,
                        1
                    ];
                    $f049ee4efddae9c4$var$logger.warn($f049ee4efddae9c4$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: "IndexedDB is not available in this environment."
                    }).message);
                    return [
                        2,
                        false
                    ];
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $dqzVW.validateIndexedDBOpenable)()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    $f049ee4efddae9c4$var$logger.warn($f049ee4efddae9c4$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: e
                    }).message);
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_validateIndexedDB.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    return $f049ee4efddae9c4$var$__initializeAnalytics.apply(this, arguments);
}
function $f049ee4efddae9c4$var$__initializeAnalytics() {
    $f049ee4efddae9c4$var$__initializeAnalytics = /**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ (0, $5YOUh._)(function(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
        var _a, dynamicConfigPromise, fidPromise, _ref, dynamicConfig, fid, configProperties;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dynamicConfigPromise = $f049ee4efddae9c4$var$fetchDynamicConfigWithRetry(app);
                    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
                    dynamicConfigPromise.then(function(config) {
                        measurementIdToAppId[config.measurementId] = config.appId;
                        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $f049ee4efddae9c4$var$logger.warn("The measurement ID in the local Firebase config (".concat(app.options.measurementId, ")") + " does not match the measurement ID fetched from the server (".concat(config.measurementId, ").") + " To ensure analytics events are always sent to the correct Analytics property," + " update the" + " measurement ID field in the local config or remove it from the local config.");
                    }).catch(function(e) {
                        return $f049ee4efddae9c4$var$logger.error(e);
                    });
                    // Add to list to track state of all dynamic config promises.
                    dynamicConfigPromisesList.push(dynamicConfigPromise);
                    fidPromise = $f049ee4efddae9c4$var$validateIndexedDB().then(function(envIsValid) {
                        if (envIsValid) return installations.getId();
                        else return undefined;
                    });
                    return [
                        4,
                        Promise.all([
                            dynamicConfigPromise,
                            fidPromise
                        ])
                    ];
                case 1:
                    _ref = (0, $kekIc._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), dynamicConfig = _ref[0], fid = _ref[1];
                    // Detect if user has already put the gtag <script> tag on this page.
                    if (!$f049ee4efddae9c4$var$findGtagScriptOnPage()) $f049ee4efddae9c4$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
                    // This command initializes gtag.js and only needs to be called once for the entire web app,
                    // but since it is idempotent, we can call it multiple times.
                    // We keep it together with other initialization logic for better code structure.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    gtagCore("js", new Date());
                    // User config added first. We don't want users to accidentally overwrite
                    // base Firebase config properties.
                    configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
                    // guard against developers accidentally setting properties with prefix `firebase_`
                    configProperties[$f049ee4efddae9c4$var$ORIGIN_KEY] = "firebase";
                    configProperties.update = true;
                    if (fid != null) configProperties[$f049ee4efddae9c4$var$GA_FID_KEY] = fid;
                    // It should be the first config command called on this GA-ID
                    // Initialize this GA-ID and set FID on it using the gtag config API.
                    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
                    // `configProperties`.
                    gtagCore("config" /* CONFIG */ , dynamicConfig.measurementId, configProperties);
                    return [
                        2,
                        dynamicConfig.measurementId
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$__initializeAnalytics.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ var $f049ee4efddae9c4$var$AnalyticsService = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsService(app) {
        (0, $6Tsgf._)(this, AnalyticsService);
        this.app = app;
    }
    (0, $hmsbi._)(AnalyticsService, [
        {
            key: "_delete",
            value: function _delete() {
                delete $f049ee4efddae9c4$var$initializationPromisesMap[this.app.options.appId];
                return Promise.resolve();
            }
        }
    ]);
    return AnalyticsService;
}();
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ var $f049ee4efddae9c4$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ var $f049ee4efddae9c4$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ var $f049ee4efddae9c4$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ var $f049ee4efddae9c4$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ var $f049ee4efddae9c4$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ var $f049ee4efddae9c4$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ var $f049ee4efddae9c4$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ var $f049ee4efddae9c4$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $f049ee4efddae9c4$export$a5a6e0b888b2c992(options) {
    if ($f049ee4efddae9c4$var$globalInitDone) throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $f049ee4efddae9c4$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $f049ee4efddae9c4$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $f049ee4efddae9c4$var$warnOnBrowserContextMismatch() {
    var mismatchedEnvMessages = [];
    if ((0, $dqzVW.isBrowserExtension)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $dqzVW.areCookiesEnabled)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        var details = mismatchedEnvMessages.map(function(message, index) {
            return "(".concat(index + 1, ") ").concat(message);
        }).join(" ");
        var err = $f049ee4efddae9c4$var$ERROR_FACTORY.create("invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $f049ee4efddae9c4$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $f049ee4efddae9c4$var$factory(app, installations, options) {
    $f049ee4efddae9c4$var$warnOnBrowserContextMismatch();
    var appId = app.options.appId;
    if (!appId) throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $f049ee4efddae9c4$var$logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + " measurement ID for this Firebase app. Falling back to the measurement ID ".concat(app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
        else throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
    }
    if ($f049ee4efddae9c4$var$initializationPromisesMap[appId] != null) throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$f049ee4efddae9c4$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $f049ee4efddae9c4$var$getOrCreateDataLayer($f049ee4efddae9c4$var$dataLayerName);
        var _wrapOrCreateGtag = $f049ee4efddae9c4$var$wrapOrCreateGtag($f049ee4efddae9c4$var$initializationPromisesMap, $f049ee4efddae9c4$var$dynamicConfigPromisesList, $f049ee4efddae9c4$var$measurementIdToAppId, $f049ee4efddae9c4$var$dataLayerName, $f049ee4efddae9c4$var$gtagName), wrappedGtag = _wrapOrCreateGtag.wrappedGtag, gtagCore = _wrapOrCreateGtag.gtagCore;
        $f049ee4efddae9c4$var$wrappedGtagFunction = wrappedGtag;
        $f049ee4efddae9c4$var$gtagCoreFunction = gtagCore;
        $f049ee4efddae9c4$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $f049ee4efddae9c4$var$initializationPromisesMap[appId] = $f049ee4efddae9c4$var$_initializeAnalytics(app, $f049ee4efddae9c4$var$dynamicConfigPromisesList, $f049ee4efddae9c4$var$measurementIdToAppId, installations, $f049ee4efddae9c4$var$gtagCoreFunction, $f049ee4efddae9c4$var$dataLayerName, options);
    var analyticsInstance = new $f049ee4efddae9c4$var$AnalyticsService(app);
    return analyticsInstance;
}
function $f049ee4efddae9c4$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    return $f049ee4efddae9c4$var$_logEvent$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_logEvent$1() {
    $f049ee4efddae9c4$var$_logEvent$1 = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ (0, $5YOUh._)(function(gtagFunction, initializationPromise, eventName, eventParams, options) {
        var measurementId, params;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("event" /* EVENT */ , eventName, eventParams);
                    return [
                        2
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    params = Object.assign(Object.assign({}, eventParams), {
                        "send_to": measurementId
                    });
                    gtagFunction("event" /* EVENT */ , eventName, params);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_logEvent$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    return $f049ee4efddae9c4$var$_setCurrentScreen$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_setCurrentScreen$1() {
    $f049ee4efddae9c4$var$_setCurrentScreen$1 = /**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ (0, $5YOUh._)(function(gtagFunction, initializationPromise, screenName, options) {
        var measurementId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("set" /* SET */ , {
                        "screen_name": screenName
                    });
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* CONFIG */ , measurementId, {
                        update: true,
                        "screen_name": screenName
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_setCurrentScreen$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    return $f049ee4efddae9c4$var$_setUserId$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_setUserId$1() {
    $f049ee4efddae9c4$var$_setUserId$1 = /**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ (0, $5YOUh._)(function(gtagFunction, initializationPromise, id, options) {
        var measurementId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("set" /* SET */ , {
                        "user_id": id
                    });
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* CONFIG */ , measurementId, {
                        update: true,
                        "user_id": id
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_setUserId$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    return $f049ee4efddae9c4$var$_setUserProperties$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_setUserProperties$1() {
    $f049ee4efddae9c4$var$_setUserProperties$1 = /**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ (0, $5YOUh._)(function(gtagFunction, initializationPromise, properties, options) {
        var flatProperties, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, measurementId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    flatProperties = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = Object.keys(properties)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            key = _step.value;
                            // use dot notation for merge behavior in gtag.js
                            flatProperties["user_properties.".concat(key)] = properties[key];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    gtagFunction("set" /* SET */ , flatProperties);
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* CONFIG */ , measurementId, {
                        update: true,
                        "user_properties": properties
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_setUserProperties$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    return $f049ee4efddae9c4$var$_setAnalyticsCollectionEnabled$1.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_setAnalyticsCollectionEnabled$1() {
    $f049ee4efddae9c4$var$_setAnalyticsCollectionEnabled$1 = /**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ (0, $5YOUh._)(function(initializationPromise, enabled) {
        var measurementId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        initializationPromise
                    ];
                case 1:
                    measurementId = _state.sent();
                    window["ga-disable-".concat(measurementId)] = !enabled;
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_setAnalyticsCollectionEnabled$1.apply(this, arguments);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $f049ee4efddae9c4$export$b0297573c90085aa() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gsN9U.getApp)();
    app = (0, $dqzVW.getModularInstance)(app);
    // Dependencies
    var analyticsProvider = (0, $gsN9U._getProvider)(app, $f049ee4efddae9c4$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $f049ee4efddae9c4$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $f049ee4efddae9c4$export$e1ffb6ba450b0317(app) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Dependencies
    var analyticsProvider = (0, $gsN9U._getProvider)(app, $f049ee4efddae9c4$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        var existingInstance = analyticsProvider.getImmediate();
        if ((0, $dqzVW.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */ );
    }
    var analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
function $f049ee4efddae9c4$export$48c17662a6902497() {
    return $f049ee4efddae9c4$var$_isSupported.apply(this, arguments);
}
function $f049ee4efddae9c4$var$_isSupported() {
    $f049ee4efddae9c4$var$_isSupported = /**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ (0, $5YOUh._)(function() {
        var isDBOpenable, error;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $dqzVW.isBrowserExtension)()) return [
                        2,
                        false
                    ];
                    if (!(0, $dqzVW.areCookiesEnabled)()) return [
                        2,
                        false
                    ];
                    if (!(0, $dqzVW.isIndexedDBAvailable)()) return [
                        2,
                        false
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $dqzVW.validateIndexedDBOpenable)()
                    ];
                case 2:
                    isDBOpenable = _state.sent();
                    return [
                        2,
                        isDBOpenable
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $f049ee4efddae9c4$var$_isSupported.apply(this, arguments);
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $f049ee4efddae9c4$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $dqzVW.getModularInstance)(analyticsInstance);
    $f049ee4efddae9c4$var$setCurrentScreen$1($f049ee4efddae9c4$var$wrappedGtagFunction, $f049ee4efddae9c4$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch(function(e) {
        return $f049ee4efddae9c4$var$logger.error(e);
    });
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $f049ee4efddae9c4$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $dqzVW.getModularInstance)(analyticsInstance);
    $f049ee4efddae9c4$var$setUserId$1($f049ee4efddae9c4$var$wrappedGtagFunction, $f049ee4efddae9c4$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch(function(e) {
        return $f049ee4efddae9c4$var$logger.error(e);
    });
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $f049ee4efddae9c4$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $dqzVW.getModularInstance)(analyticsInstance);
    $f049ee4efddae9c4$var$setUserProperties$1($f049ee4efddae9c4$var$wrappedGtagFunction, $f049ee4efddae9c4$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch(function(e) {
        return $f049ee4efddae9c4$var$logger.error(e);
    });
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $f049ee4efddae9c4$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $dqzVW.getModularInstance)(analyticsInstance);
    $f049ee4efddae9c4$var$setAnalyticsCollectionEnabled$1($f049ee4efddae9c4$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch(function(e) {
        return $f049ee4efddae9c4$var$logger.error(e);
    });
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $f049ee4efddae9c4$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $dqzVW.getModularInstance)(analyticsInstance);
    $f049ee4efddae9c4$var$logEvent$1($f049ee4efddae9c4$var$wrappedGtagFunction, $f049ee4efddae9c4$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch(function(e) {
        return $f049ee4efddae9c4$var$logger.error(e);
    });
}
var $f049ee4efddae9c4$var$name = "@firebase/analytics";
var $f049ee4efddae9c4$var$version = "0.7.4";
/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */ function $f049ee4efddae9c4$var$registerAnalytics() {
    (0, $gsN9U._registerComponent)(new (0, $8WxDc.Component)($f049ee4efddae9c4$var$ANALYTICS_TYPE, function(container, param) {
        var analyticsOptions = param.options;
        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var installations = container.getProvider("installations-internal").getImmediate();
        return $f049ee4efddae9c4$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* PUBLIC */ ));
    (0, $gsN9U._registerComponent)(new (0, $8WxDc.Component)("analytics-internal", internalFactory, "PRIVATE" /* PRIVATE */ ));
    (0, $gsN9U.registerVersion)($f049ee4efddae9c4$var$name, $f049ee4efddae9c4$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $gsN9U.registerVersion)($f049ee4efddae9c4$var$name, $f049ee4efddae9c4$var$version, "esm2017");
    function internalFactory(container) {
        try {
            var analytics = container.getProvider($f049ee4efddae9c4$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: function(eventName, eventParams, options) {
                    return $f049ee4efddae9c4$export$5e9eec8001665ac5(analytics, eventName, eventParams, options);
                }
            };
        } catch (e) {
            throw $f049ee4efddae9c4$var$ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$f049ee4efddae9c4$var$registerAnalytics();

});
parcelRegister("eY6nt", function(module, exports) {

var $5YOUh = parcelRequire("5YOUh");

var $fKBt2 = parcelRequire("fKBt2");

var $kRmIq = parcelRequire("kRmIq");

var $j4B9x = parcelRequire("j4B9x");

var $gsN9U = parcelRequire("gsN9U");

var $8WxDc = parcelRequire("8WxDc");

var $dqzVW = parcelRequire("dqzVW");

var $6qqlZ = parcelRequire("6qqlZ");
var $ae5b9dbddbfca4cc$var$name = "@firebase/installations";
var $ae5b9dbddbfca4cc$var$version = "0.5.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$PENDING_TIMEOUT_MS = 10000;
var $ae5b9dbddbfca4cc$var$PACKAGE_VERSION = "w:".concat($ae5b9dbddbfca4cc$var$version);
var $ae5b9dbddbfca4cc$var$INTERNAL_AUTH_VERSION = "FIS_v2";
var $ae5b9dbddbfca4cc$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
var $ae5b9dbddbfca4cc$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
var $ae5b9dbddbfca4cc$var$SERVICE = "installations";
var $ae5b9dbddbfca4cc$var$SERVICE_NAME = "Installations";
var $ae5b9dbddbfca4cc$var$_obj;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$ERROR_DESCRIPTION_MAP = ($ae5b9dbddbfca4cc$var$_obj = {}, (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ , 'Missing App configuration value: "{$valueName}"'), (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "not-registered" /* NOT_REGISTERED */ , "Firebase Installation is not registered."), (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "installation-not-found" /* INSTALLATION_NOT_FOUND */ , "Firebase Installation not found."), (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "request-failed" /* REQUEST_FAILED */ , '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"'), (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "app-offline" /* APP_OFFLINE */ , "Could not process request. Application offline."), (0, $fKBt2._)($ae5b9dbddbfca4cc$var$_obj, "delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ , "Can't delete installation while there is a pending registration request."), $ae5b9dbddbfca4cc$var$_obj);
var $ae5b9dbddbfca4cc$var$ERROR_FACTORY = new (0, $dqzVW.ErrorFactory)($ae5b9dbddbfca4cc$var$SERVICE, $ae5b9dbddbfca4cc$var$SERVICE_NAME, $ae5b9dbddbfca4cc$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $ae5b9dbddbfca4cc$var$isServerError(error) {
    return error instanceof (0, $dqzVW.FirebaseError) && error.code.includes("request-failed" /* REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ae5b9dbddbfca4cc$var$getInstallationsEndpoint(param) {
    var projectId = param.projectId;
    return "".concat($ae5b9dbddbfca4cc$var$INSTALLATIONS_API_URL, "/projects/").concat(projectId, "/installations");
}
function $ae5b9dbddbfca4cc$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */ ,
        expiresIn: $ae5b9dbddbfca4cc$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function $ae5b9dbddbfca4cc$var$getErrorFromResponse(requestName, response) {
    return $ae5b9dbddbfca4cc$var$_getErrorFromResponse.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_getErrorFromResponse() {
    $ae5b9dbddbfca4cc$var$_getErrorFromResponse = (0, $5YOUh._)(function(requestName, response) {
        var responseJson, errorData;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    responseJson = _state.sent();
                    errorData = responseJson.error;
                    return [
                        2,
                        $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */ , {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_getErrorFromResponse.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$getHeaders(param) {
    var apiKey = param.apiKey;
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $ae5b9dbddbfca4cc$var$getHeadersWithAuth(appConfig, param) {
    var refreshToken = param.refreshToken;
    var headers = $ae5b9dbddbfca4cc$var$getHeaders(appConfig);
    headers.append("Authorization", $ae5b9dbddbfca4cc$var$getAuthorizationHeader(refreshToken));
    return headers;
}
function $ae5b9dbddbfca4cc$var$retryIfServerError(fn) {
    return $ae5b9dbddbfca4cc$var$_retryIfServerError.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_retryIfServerError() {
    $ae5b9dbddbfca4cc$var$_retryIfServerError = /**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ (0, $5YOUh._)(function(fn) {
        var result;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fn()
                    ];
                case 1:
                    result = _state.sent();
                    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
                    return [
                        2,
                        fn()
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_retryIfServerError.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $ae5b9dbddbfca4cc$var$getAuthorizationHeader(refreshToken) {
    return "".concat($ae5b9dbddbfca4cc$var$INTERNAL_AUTH_VERSION, " ").concat(refreshToken);
}
function $ae5b9dbddbfca4cc$var$createInstallationRequest(appConfig, _) {
    return $ae5b9dbddbfca4cc$var$_createInstallationRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_createInstallationRequest() {
    $ae5b9dbddbfca4cc$var$_createInstallationRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5YOUh._)(function(appConfig, param) {
        var fid, endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fid = param.fid;
                    endpoint = $ae5b9dbddbfca4cc$var$getInstallationsEndpoint(appConfig);
                    headers = $ae5b9dbddbfca4cc$var$getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: $ae5b9dbddbfca4cc$var$INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: $ae5b9dbddbfca4cc$var$PACKAGE_VERSION
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseValue = _state.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */ ,
                        refreshToken: responseValue.refreshToken,
                        authToken: $ae5b9dbddbfca4cc$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [
                        2,
                        registeredInstallationEntry
                    ];
                case 3:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getErrorFromResponse("Create Installation", response)
                    ];
                case 4:
                    throw _state.sent();
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_createInstallationRequest.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $ae5b9dbddbfca4cc$var$sleep(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ae5b9dbddbfca4cc$var$bufferToBase64UrlSafe(array) {
    var _String;
    var b64 = btoa((_String = String).fromCharCode.apply(_String, (0, $kRmIq._)(array)));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var $ae5b9dbddbfca4cc$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $ae5b9dbddbfca4cc$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        var fid = $ae5b9dbddbfca4cc$var$encode(fidByteArray);
        return $ae5b9dbddbfca4cc$var$VALID_FID_PATTERN.test(fid) ? fid : $ae5b9dbddbfca4cc$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $ae5b9dbddbfca4cc$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $ae5b9dbddbfca4cc$var$encode(fidByteArray) {
    var b64String = $ae5b9dbddbfca4cc$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $ae5b9dbddbfca4cc$var$getKey(appConfig) {
    return "".concat(appConfig.appName, "!").concat(appConfig.appId);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $ae5b9dbddbfca4cc$var$fidChanged(appConfig, fid) {
    var key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
    $ae5b9dbddbfca4cc$var$callFidChangeCallbacks(key, fid);
    $ae5b9dbddbfca4cc$var$broadcastFidChange(key, fid);
}
function $ae5b9dbddbfca4cc$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $ae5b9dbddbfca4cc$var$getBroadcastChannel();
    var key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
    var callbackSet = $ae5b9dbddbfca4cc$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $ae5b9dbddbfca4cc$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $ae5b9dbddbfca4cc$var$removeCallback(appConfig, callback) {
    var key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
    var callbackSet = $ae5b9dbddbfca4cc$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $ae5b9dbddbfca4cc$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $ae5b9dbddbfca4cc$var$closeBroadcastChannel();
}
function $ae5b9dbddbfca4cc$var$callFidChangeCallbacks(key, fid) {
    var callbacks = $ae5b9dbddbfca4cc$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var callback = _step.value;
            callback(fid);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $ae5b9dbddbfca4cc$var$broadcastFidChange(key, fid) {
    var channel = $ae5b9dbddbfca4cc$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $ae5b9dbddbfca4cc$var$closeBroadcastChannel();
}
var $ae5b9dbddbfca4cc$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $ae5b9dbddbfca4cc$var$getBroadcastChannel() {
    if (!$ae5b9dbddbfca4cc$var$broadcastChannel && "BroadcastChannel" in self) {
        $ae5b9dbddbfca4cc$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $ae5b9dbddbfca4cc$var$broadcastChannel.onmessage = function(e) {
            $ae5b9dbddbfca4cc$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $ae5b9dbddbfca4cc$var$broadcastChannel;
}
function $ae5b9dbddbfca4cc$var$closeBroadcastChannel() {
    if ($ae5b9dbddbfca4cc$var$fidChangeCallbacks.size === 0 && $ae5b9dbddbfca4cc$var$broadcastChannel) {
        $ae5b9dbddbfca4cc$var$broadcastChannel.close();
        $ae5b9dbddbfca4cc$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$DATABASE_NAME = "firebase-installations-database";
var $ae5b9dbddbfca4cc$var$DATABASE_VERSION = 1;
var $ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME = "firebase-installations-store";
var $ae5b9dbddbfca4cc$var$dbPromise = null;
function $ae5b9dbddbfca4cc$var$getDbPromise() {
    if (!$ae5b9dbddbfca4cc$var$dbPromise) $ae5b9dbddbfca4cc$var$dbPromise = (0, $6qqlZ.openDb)($ae5b9dbddbfca4cc$var$DATABASE_NAME, $ae5b9dbddbfca4cc$var$DATABASE_VERSION, function(upgradeDB) {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch(upgradeDB.oldVersion){
            case 0:
                upgradeDB.createObjectStore($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME);
        }
    });
    return $ae5b9dbddbfca4cc$var$dbPromise;
}
function $ae5b9dbddbfca4cc$var$set(appConfig, value) {
    return $ae5b9dbddbfca4cc$var$_set.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_set() {
    $ae5b9dbddbfca4cc$var$_set = /** Assigns or overwrites the record for the given key with the given value. */ (0, $5YOUh._)(function(appConfig, value) {
        var key, db, tx, objectStore, oldValue;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME);
                    return [
                        4,
                        objectStore.get(key)
                    ];
                case 2:
                    oldValue = _state.sent();
                    return [
                        4,
                        objectStore.put(value, key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        tx.complete
                    ];
                case 4:
                    _state.sent();
                    if (!oldValue || oldValue.fid !== value.fid) $ae5b9dbddbfca4cc$var$fidChanged(appConfig, value.fid);
                    return [
                        2,
                        value
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_set.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$remove(appConfig) {
    return $ae5b9dbddbfca4cc$var$_remove.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_remove() {
    $ae5b9dbddbfca4cc$var$_remove = /** Removes record(s) from the objectStore that match the given key. */ (0, $5YOUh._)(function(appConfig) {
        var key, db, tx;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4,
                        tx.objectStore($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME).delete(key)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.complete
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_remove.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$update(appConfig, updateFn) {
    return $ae5b9dbddbfca4cc$var$_update.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_update() {
    $ae5b9dbddbfca4cc$var$_update = /**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ (0, $5YOUh._)(function(appConfig, updateFn) {
        var key, db, tx, store, oldValue, newValue;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $ae5b9dbddbfca4cc$var$getKey(appConfig);
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME, "readwrite");
                    store = tx.objectStore($ae5b9dbddbfca4cc$var$OBJECT_STORE_NAME);
                    return [
                        4,
                        store.get(key)
                    ];
                case 2:
                    oldValue = _state.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        store.delete(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        store.put(newValue, key)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        tx.complete
                    ];
                case 7:
                    _state.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $ae5b9dbddbfca4cc$var$fidChanged(appConfig, newValue.fid);
                    return [
                        2,
                        newValue
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_update.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$getInstallationEntry(appConfig) {
    return $ae5b9dbddbfca4cc$var$_getInstallationEntry.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_getInstallationEntry() {
    $ae5b9dbddbfca4cc$var$_getInstallationEntry = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ (0, $5YOUh._)(function(appConfig) {
        var registrationPromise, installationEntry, _tmp;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$update(appConfig, function(oldEntry) {
                            var installationEntry = $ae5b9dbddbfca4cc$var$updateOrCreateInstallationEntry(oldEntry);
                            var entryWithPromise = $ae5b9dbddbfca4cc$var$triggerRegistrationIfNecessary(appConfig, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        })
                    ];
                case 1:
                    installationEntry = _state.sent();
                    if (!(installationEntry.fid === $ae5b9dbddbfca4cc$var$INVALID_FID)) return [
                        3,
                        3
                    ];
                    _tmp = {};
                    return [
                        4,
                        registrationPromise
                    ];
                case 2:
                    // FID generation failed. Waiting for the FID from the server.
                    return [
                        2,
                        (_tmp.installationEntry = _state.sent(), _tmp)
                    ];
                case 3:
                    return [
                        2,
                        {
                            installationEntry: installationEntry,
                            registrationPromise: registrationPromise
                        }
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_getInstallationEntry.apply(this, arguments);
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $ae5b9dbddbfca4cc$var$updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: $ae5b9dbddbfca4cc$var$generateFid(),
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return $ae5b9dbddbfca4cc$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $ae5b9dbddbfca4cc$var$triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject($ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        var registrationPromise = $ae5b9dbddbfca4cc$var$registerInstallation(appConfig, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $ae5b9dbddbfca4cc$var$waitUntilFidRegistration(appConfig)
    };
    else return {
        installationEntry: installationEntry
    };
}
function $ae5b9dbddbfca4cc$var$registerInstallation(appConfig, installationEntry) {
    return $ae5b9dbddbfca4cc$var$_registerInstallation.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_registerInstallation() {
    $ae5b9dbddbfca4cc$var$_registerInstallation = /** This will be executed only once for each new Firebase Installation. */ (0, $5YOUh._)(function(appConfig, installationEntry) {
        var registeredInstallationEntry, e;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        7
                    ]);
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$createInstallationRequest(appConfig, installationEntry)
                    ];
                case 1:
                    registeredInstallationEntry = _state.sent();
                    return [
                        2,
                        $ae5b9dbddbfca4cc$var$set(appConfig, registeredInstallationEntry)
                    ];
                case 2:
                    e = _state.sent();
                    if (!($ae5b9dbddbfca4cc$var$isServerError(e) && e.customData.serverCode === 409)) return [
                        3,
                        4
                    ];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$remove(appConfig)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    // Registration failed. Set FID as not registered.
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$set(appConfig, {
                            fid: installationEntry.fid,
                            registrationStatus: 0 /* NOT_STARTED */ 
                        })
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    throw e;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_registerInstallation.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$waitUntilFidRegistration(appConfig) {
    return $ae5b9dbddbfca4cc$var$_waitUntilFidRegistration.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_waitUntilFidRegistration() {
    $ae5b9dbddbfca4cc$var$_waitUntilFidRegistration = /** Call if FID registration is pending in another request. */ (0, $5YOUh._)(function(appConfig) {
        var entry, _ref, installationEntry, registrationPromise;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$updateInstallationRequest(appConfig)
                    ];
                case 1:
                    entry = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3,
                        5
                    ];
                    // createInstallation request still in progress.
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$sleep(100)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$updateInstallationRequest(appConfig)
                    ];
                case 4:
                    entry = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */ )) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getInstallationEntry(appConfig)
                    ];
                case 6:
                    _ref = _state.sent(), installationEntry = _ref.installationEntry, registrationPromise = _ref.registrationPromise;
                    if (registrationPromise) return [
                        2,
                        registrationPromise
                    ];
                    else // if there is no registrationPromise, entry is registered.
                    return [
                        2,
                        installationEntry
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        entry
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_waitUntilFidRegistration.apply(this, arguments);
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $ae5b9dbddbfca4cc$var$updateInstallationRequest(appConfig) {
    return $ae5b9dbddbfca4cc$var$update(appConfig, function(oldEntry) {
        if (!oldEntry) throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */ );
        return $ae5b9dbddbfca4cc$var$clearTimedOutRequest(oldEntry);
    });
}
function $ae5b9dbddbfca4cc$var$clearTimedOutRequest(entry) {
    if ($ae5b9dbddbfca4cc$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return entry;
}
function $ae5b9dbddbfca4cc$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* IN_PROGRESS */  && installationEntry.registrationTime + $ae5b9dbddbfca4cc$var$PENDING_TIMEOUT_MS < Date.now();
}
function $ae5b9dbddbfca4cc$var$generateAuthTokenRequest(_, installationEntry) {
    return $ae5b9dbddbfca4cc$var$_generateAuthTokenRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_generateAuthTokenRequest() {
    $ae5b9dbddbfca4cc$var$_generateAuthTokenRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5YOUh._)(function(param, installationEntry) {
        var appConfig, platformLoggerProvider, endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appConfig = param.appConfig, platformLoggerProvider = param.platformLoggerProvider;
                    endpoint = $ae5b9dbddbfca4cc$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = $ae5b9dbddbfca4cc$var$getHeadersWithAuth(appConfig, installationEntry);
                    // If platform logger exists, add the platform info string to the header.
                    platformLogger = platformLoggerProvider.getImmediate({
                        optional: true
                    });
                    if (platformLogger) headers.append("x-firebase-client", platformLogger.getPlatformInfoString());
                    body = {
                        installation: {
                            sdkVersion: $ae5b9dbddbfca4cc$var$PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseValue = _state.sent();
                    completedAuthToken = $ae5b9dbddbfca4cc$var$extractAuthTokenInfoFromResponse(responseValue);
                    return [
                        2,
                        completedAuthToken
                    ];
                case 3:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getErrorFromResponse("Generate Auth Token", response)
                    ];
                case 4:
                    throw _state.sent();
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_generateAuthTokenRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$getGenerateAuthTokenEndpoint(appConfig, param) {
    var fid = param.fid;
    return "".concat($ae5b9dbddbfca4cc$var$getInstallationsEndpoint(appConfig), "/").concat(fid, "/authTokens:generate");
}
function $ae5b9dbddbfca4cc$var$refreshAuthToken(installations) {
    return $ae5b9dbddbfca4cc$var$_refreshAuthToken.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_refreshAuthToken() {
    $ae5b9dbddbfca4cc$var$_refreshAuthToken = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ (0, $5YOUh._)(function(installations) {
        var forceRefresh, tokenPromise, entry, authToken, _tmp;
        var _arguments = arguments;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$update(installations.appConfig, function(oldEntry) {
                            if (!$ae5b9dbddbfca4cc$var$isEntryRegistered(oldEntry)) throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
                            var oldAuthToken = oldEntry.authToken;
                            if (!forceRefresh && $ae5b9dbddbfca4cc$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
                            return oldEntry;
                            else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */ ) {
                                // There already is a token request in progress.
                                tokenPromise = $ae5b9dbddbfca4cc$var$waitUntilAuthTokenRequest(installations, forceRefresh);
                                return oldEntry;
                            } else {
                                // No token or token expired.
                                if (!navigator.onLine) throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                                var inProgressEntry = $ae5b9dbddbfca4cc$var$makeAuthTokenRequestInProgressEntry(oldEntry);
                                tokenPromise = $ae5b9dbddbfca4cc$var$fetchAuthTokenFromServer(installations, inProgressEntry);
                                return inProgressEntry;
                            }
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (!tokenPromise) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        tokenPromise
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp = entry.authToken;
                    _state.label = 4;
                case 4:
                    authToken = _tmp;
                    return [
                        2,
                        authToken
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_refreshAuthToken.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    return $ae5b9dbddbfca4cc$var$_waitUntilAuthTokenRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_waitUntilAuthTokenRequest() {
    $ae5b9dbddbfca4cc$var$_waitUntilAuthTokenRequest = /**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ (0, $5YOUh._)(function(installations, forceRefresh) {
        var entry, authToken;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$updateAuthTokenRequest(installations.appConfig)
                    ];
                case 1:
                    entry = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */ )) return [
                        3,
                        5
                    ];
                    // generateAuthToken still in progress.
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$sleep(100)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$updateAuthTokenRequest(installations.appConfig)
                    ];
                case 4:
                    entry = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
                    return [
                        2,
                        $ae5b9dbddbfca4cc$var$refreshAuthToken(installations, forceRefresh)
                    ];
                    else return [
                        2,
                        authToken
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_waitUntilAuthTokenRequest.apply(this, arguments);
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $ae5b9dbddbfca4cc$var$updateAuthTokenRequest(appConfig) {
    return $ae5b9dbddbfca4cc$var$update(appConfig, function(oldEntry) {
        if (!$ae5b9dbddbfca4cc$var$isEntryRegistered(oldEntry)) throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
        var oldAuthToken = oldEntry.authToken;
        if ($ae5b9dbddbfca4cc$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
function $ae5b9dbddbfca4cc$var$fetchAuthTokenFromServer(installations, installationEntry) {
    return $ae5b9dbddbfca4cc$var$_fetchAuthTokenFromServer.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_fetchAuthTokenFromServer() {
    $ae5b9dbddbfca4cc$var$_fetchAuthTokenFromServer = (0, $5YOUh._)(function(installations, installationEntry) {
        var authToken, updatedInstallationEntry, e, updatedInstallationEntry1;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$generateAuthTokenRequest(installations, installationEntry)
                    ];
                case 1:
                    authToken = _state.sent();
                    updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                        authToken: authToken
                    });
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$set(installations.appConfig, updatedInstallationEntry)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        authToken
                    ];
                case 3:
                    e = _state.sent();
                    if (!($ae5b9dbddbfca4cc$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404))) return [
                        3,
                        5
                    ];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$remove(installations.appConfig)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    updatedInstallationEntry1 = Object.assign(Object.assign({}, installationEntry), {
                        authToken: {
                            requestStatus: 0 /* NOT_STARTED */ 
                        }
                    });
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$set(installations.appConfig, updatedInstallationEntry1)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    throw e;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_fetchAuthTokenFromServer.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* COMPLETED */ ;
}
function $ae5b9dbddbfca4cc$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* COMPLETED */  && !$ae5b9dbddbfca4cc$var$isAuthTokenExpired(authToken);
}
function $ae5b9dbddbfca4cc$var$isAuthTokenExpired(authToken) {
    var now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $ae5b9dbddbfca4cc$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $ae5b9dbddbfca4cc$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $ae5b9dbddbfca4cc$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* IN_PROGRESS */  && authToken.requestTime + $ae5b9dbddbfca4cc$var$PENDING_TIMEOUT_MS < Date.now();
}
function $ae5b9dbddbfca4cc$export$218c8c3169c024d2(installations) {
    return $ae5b9dbddbfca4cc$var$_getId.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_getId() {
    $ae5b9dbddbfca4cc$var$_getId = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ (0, $5YOUh._)(function(installations) {
        var installationsImpl, _ref, installationEntry, registrationPromise;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    installationsImpl = installations;
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getInstallationEntry(installationsImpl.appConfig)
                    ];
                case 1:
                    _ref = _state.sent(), installationEntry = _ref.installationEntry, registrationPromise = _ref.registrationPromise;
                    if (registrationPromise) registrationPromise.catch(console.error);
                    else // If the installation is already registered, update the authentication
                    // token if needed.
                    $ae5b9dbddbfca4cc$var$refreshAuthToken(installationsImpl).catch(console.error);
                    return [
                        2,
                        installationEntry.fid
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_getId.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$export$257b2d10b709d8ef(installations) {
    return $ae5b9dbddbfca4cc$var$_getToken.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_getToken() {
    $ae5b9dbddbfca4cc$var$_getToken = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $5YOUh._)(function(installations) {
        var forceRefresh, installationsImpl, authToken;
        var _arguments = arguments;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    installationsImpl = installations;
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$completeInstallationRegistration(installationsImpl.appConfig)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$refreshAuthToken(installationsImpl, forceRefresh)
                    ];
                case 2:
                    authToken = _state.sent();
                    return [
                        2,
                        authToken.token
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_getToken.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$completeInstallationRegistration(appConfig) {
    return $ae5b9dbddbfca4cc$var$_completeInstallationRegistration.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_completeInstallationRegistration() {
    $ae5b9dbddbfca4cc$var$_completeInstallationRegistration = (0, $5YOUh._)(function(appConfig) {
        var registrationPromise;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getInstallationEntry(appConfig)
                    ];
                case 1:
                    registrationPromise = _state.sent().registrationPromise;
                    if (!registrationPromise) return [
                        3,
                        3
                    ];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [
                        4,
                        registrationPromise
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_completeInstallationRegistration.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$deleteInstallationRequest(appConfig, installationEntry) {
    return $ae5b9dbddbfca4cc$var$_deleteInstallationRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_deleteInstallationRequest() {
    $ae5b9dbddbfca4cc$var$_deleteInstallationRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5YOUh._)(function(appConfig, installationEntry) {
        var endpoint, headers, request, response;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endpoint = $ae5b9dbddbfca4cc$var$getDeleteEndpoint(appConfig, installationEntry);
                    headers = $ae5b9dbddbfca4cc$var$getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: "DELETE",
                        headers: headers
                    };
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$getErrorFromResponse("Delete Installation", response)
                    ];
                case 2:
                    throw _state.sent();
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_deleteInstallationRequest.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$getDeleteEndpoint(appConfig, param) {
    var fid = param.fid;
    return "".concat($ae5b9dbddbfca4cc$var$getInstallationsEndpoint(appConfig), "/").concat(fid);
}
function $ae5b9dbddbfca4cc$export$5f6b87a08674814c(installations) {
    return $ae5b9dbddbfca4cc$var$_deleteInstallations.apply(this, arguments);
}
function $ae5b9dbddbfca4cc$var$_deleteInstallations() {
    $ae5b9dbddbfca4cc$var$_deleteInstallations = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ (0, $5YOUh._)(function(installations) {
        var appConfig, entry;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appConfig = installations.appConfig;
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$update(appConfig, function(oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
                            return undefined;
                            return oldEntry;
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (!entry) return [
                        3,
                        6
                    ];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3,
                        2
                    ];
                    // Can't delete while trying to register.
                    throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ );
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */ )) return [
                        3,
                        6
                    ];
                    if (!!navigator.onLine) return [
                        3,
                        3
                    ];
                    throw $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                case 3:
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$deleteInstallationRequest(appConfig, entry)
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        $ae5b9dbddbfca4cc$var$remove(appConfig)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $ae5b9dbddbfca4cc$var$_deleteInstallations.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $ae5b9dbddbfca4cc$export$ceb4c11381bc36e8(installations, callback) {
    var appConfig = installations.appConfig;
    $ae5b9dbddbfca4cc$var$addCallback(appConfig, callback);
    return function() {
        $ae5b9dbddbfca4cc$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $ae5b9dbddbfca4cc$export$9bfc115e43431ff5() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $gsN9U.getApp)();
    var installationsImpl = (0, $gsN9U._getProvider)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ae5b9dbddbfca4cc$var$extractAppConfig(app) {
    if (!app || !app.options) throw $ae5b9dbddbfca4cc$var$getMissingValueError("App Configuration");
    if (!app.name) throw $ae5b9dbddbfca4cc$var$getMissingValueError("App Name");
    // Required app config keys
    var configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = configKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var keyName = _step.value;
            if (!app.options[keyName]) throw $ae5b9dbddbfca4cc$var$getMissingValueError(keyName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $ae5b9dbddbfca4cc$var$getMissingValueError(valueName) {
    return $ae5b9dbddbfca4cc$var$ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ae5b9dbddbfca4cc$var$INSTALLATIONS_NAME = "installations";
var $ae5b9dbddbfca4cc$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
var $ae5b9dbddbfca4cc$var$publicFactory = function(container) {
    var app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    var appConfig = $ae5b9dbddbfca4cc$var$extractAppConfig(app);
    var platformLoggerProvider = (0, $gsN9U._getProvider)(app, "platform-logger");
    var installationsImpl = {
        app: app,
        appConfig: appConfig,
        platformLoggerProvider: platformLoggerProvider,
        _delete: function() {
            return Promise.resolve();
        }
    };
    return installationsImpl;
};
var $ae5b9dbddbfca4cc$var$internalFactory = function(container) {
    var app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    var installations = (0, $gsN9U._getProvider)(app, $ae5b9dbddbfca4cc$var$INSTALLATIONS_NAME).getImmediate();
    var installationsInternal = {
        getId: function() {
            return $ae5b9dbddbfca4cc$export$218c8c3169c024d2(installations);
        },
        getToken: function(forceRefresh) {
            return $ae5b9dbddbfca4cc$export$257b2d10b709d8ef(installations, forceRefresh);
        }
    };
    return installationsInternal;
};
function $ae5b9dbddbfca4cc$var$registerInstallations() {
    (0, $gsN9U._registerComponent)(new (0, $8WxDc.Component)($ae5b9dbddbfca4cc$var$INSTALLATIONS_NAME, $ae5b9dbddbfca4cc$var$publicFactory, "PUBLIC" /* PUBLIC */ ));
    (0, $gsN9U._registerComponent)(new (0, $8WxDc.Component)($ae5b9dbddbfca4cc$var$INSTALLATIONS_NAME_INTERNAL, $ae5b9dbddbfca4cc$var$internalFactory, "PRIVATE" /* PRIVATE */ ));
}
/**
 * Firebase Installations
 *
 * @packageDocumentation
 */ $ae5b9dbddbfca4cc$var$registerInstallations();
(0, $gsN9U.registerVersion)($ae5b9dbddbfca4cc$var$name, $ae5b9dbddbfca4cc$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $gsN9U.registerVersion)($ae5b9dbddbfca4cc$var$name, $ae5b9dbddbfca4cc$var$version, "esm2017");

});
parcelRegister("6qqlZ", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function toArray(arr) {
        return Array.prototype.slice.call(arr);
    }
    function promisifyRequest(request) {
        return new Promise(function(resolve, reject) {
            request.onsuccess = function() {
                resolve(request.result);
            };
            request.onerror = function() {
                reject(request.error);
            };
        });
    }
    function promisifyRequestCall(obj, method, args) {
        var request;
        var p = new Promise(function(resolve, reject) {
            request = obj[method].apply(obj, args);
            promisifyRequest(request).then(resolve, reject);
        });
        p.request = request;
        return p;
    }
    function promisifyCursorRequestCall(obj, method, args) {
        var p = promisifyRequestCall(obj, method, args);
        return p.then(function(value) {
            if (!value) return;
            return new Cursor(value, p.request);
        });
    }
    function proxyProperties(ProxyClass, targetProp, properties) {
        properties.forEach(function(prop) {
            Object.defineProperty(ProxyClass.prototype, prop, {
                get: function get() {
                    return this[targetProp][prop];
                },
                set: function set(val) {
                    this[targetProp][prop] = val;
                }
            });
        });
    }
    function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return this[targetProp][prop].apply(this[targetProp], arguments);
            };
        });
    }
    function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyCursorRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function Index(index) {
        this._index = index;
    }
    proxyProperties(Index, "_index", [
        "name",
        "keyPath",
        "multiEntry",
        "unique"
    ]);
    proxyRequestMethods(Index, "_index", IDBIndex, [
        "get",
        "getKey",
        "getAll",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(Index, "_index", IDBIndex, [
        "openCursor",
        "openKeyCursor"
    ]);
    function Cursor(cursor, request) {
        this._cursor = cursor;
        this._request = request;
    }
    proxyProperties(Cursor, "_cursor", [
        "direction",
        "key",
        "primaryKey",
        "value"
    ]);
    proxyRequestMethods(Cursor, "_cursor", IDBCursor, [
        "update",
        "delete"
    ]);
    // proxy 'next' methods
    [
        "advance",
        "continue",
        "continuePrimaryKey"
    ].forEach(function(methodName) {
        if (!(methodName in IDBCursor.prototype)) return;
        Cursor.prototype[methodName] = function() {
            var cursor = this;
            var args = arguments;
            return Promise.resolve().then(function() {
                cursor._cursor[methodName].apply(cursor._cursor, args);
                return promisifyRequest(cursor._request).then(function(value) {
                    if (!value) return;
                    return new Cursor(value, cursor._request);
                });
            });
        };
    });
    function ObjectStore(store) {
        this._store = store;
    }
    ObjectStore.prototype.createIndex = function() {
        return new Index(this._store.createIndex.apply(this._store, arguments));
    };
    ObjectStore.prototype.index = function() {
        return new Index(this._store.index.apply(this._store, arguments));
    };
    proxyProperties(ObjectStore, "_store", [
        "name",
        "keyPath",
        "indexNames",
        "autoIncrement"
    ]);
    proxyRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "put",
        "add",
        "delete",
        "clear",
        "get",
        "getAll",
        "getKey",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "openCursor",
        "openKeyCursor"
    ]);
    proxyMethods(ObjectStore, "_store", IDBObjectStore, [
        "deleteIndex"
    ]);
    function Transaction(idbTransaction) {
        this._tx = idbTransaction;
        this.complete = new Promise(function(resolve, reject) {
            idbTransaction.oncomplete = function() {
                resolve();
            };
            idbTransaction.onerror = function() {
                reject(idbTransaction.error);
            };
            idbTransaction.onabort = function() {
                reject(idbTransaction.error);
            };
        });
    }
    Transaction.prototype.objectStore = function() {
        return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
    };
    proxyProperties(Transaction, "_tx", [
        "objectStoreNames",
        "mode"
    ]);
    proxyMethods(Transaction, "_tx", IDBTransaction, [
        "abort"
    ]);
    function UpgradeDB(db, oldVersion, transaction) {
        this._db = db;
        this.oldVersion = oldVersion;
        this.transaction = new Transaction(transaction);
    }
    UpgradeDB.prototype.createObjectStore = function() {
        return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
    };
    proxyProperties(UpgradeDB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(UpgradeDB, "_db", IDBDatabase, [
        "deleteObjectStore",
        "close"
    ]);
    function DB(db) {
        this._db = db;
    }
    DB.prototype.transaction = function() {
        return new Transaction(this._db.transaction.apply(this._db, arguments));
    };
    proxyProperties(DB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(DB, "_db", IDBDatabase, [
        "close"
    ]);
    // Add cursor iterators
    // TODO: remove this once browsers do the right thing with promises
    [
        "openCursor",
        "openKeyCursor"
    ].forEach(function(funcName) {
        [
            ObjectStore,
            Index
        ].forEach(function(Constructor) {
            // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
            if (!(funcName in Constructor.prototype)) return;
            Constructor.prototype[funcName.replace("open", "iterate")] = function() {
                var args = toArray(arguments);
                var callback = args[args.length - 1];
                var nativeObject = this._store || this._index;
                var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
                request.onsuccess = function() {
                    callback(request.result);
                };
            };
        });
    });
    // polyfill getAll
    [
        Index,
        ObjectStore
    ].forEach(function(Constructor) {
        if (Constructor.prototype.getAll) return;
        Constructor.prototype.getAll = function(query, count) {
            var instance = this;
            var items = [];
            return new Promise(function(resolve) {
                instance.iterateCursor(query, function(cursor) {
                    if (!cursor) {
                        resolve(items);
                        return;
                    }
                    items.push(cursor.value);
                    if (count !== undefined && items.length == count) {
                        resolve(items);
                        return;
                    }
                    cursor.continue();
                });
            });
        };
    });
    function openDb(name, version, upgradeCallback) {
        var p = promisifyRequestCall(indexedDB, "open", [
            name,
            version
        ]);
        var request = p.request;
        if (request) request.onupgradeneeded = function(event) {
            if (upgradeCallback) upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        };
        return p.then(function(db) {
            return new DB(db);
        });
    }
    function deleteDb(name) {
        return promisifyRequestCall(indexedDB, "deleteDatabase", [
            name
        ]);
    }
    exports1.openDb = openDb;
    exports1.deleteDb = deleteDb;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});




})();
//# sourceMappingURL=index.esm.b6e87719.js.map
